import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MicroModal from "micromodal";

import Typography from "../../../../Typography";
import FieldContainer from "../../../../FieldContainer/FieldContainer";
import SatisfactionSelect from "./SatisfactionSelect/SatisfactionSelect";
import StatusSelect from "./StatusSelect/StatusSelect";
import { cloneDeep } from "lodash";

import { ReactComponent as CheckCirclIcon } from "../../../../../build/images/nps-dashboard-icons/check-circle.svg";
import { ReactComponent as PermPhoneMsgIcon } from "../../../../../build/images/nps-dashboard-icons/perm_phone_msg.svg";
import { ReactComponent as CommentIcon } from "../../../../../build/images/nps-dashboard-icons/commenticon.svg";
import { ReactComponent as WhatsappIcon } from "../../../../../build/images/nps-dashboard-icons/channels/whatsapp.svg";
import { ReactComponent as DeleteIcon } from "../../../../../build/images/nps-dashboard-icons/delete.svg";
import { ReactComponent as HistoryIcon } from "../../../../../build/images/nps-dashboard-icons/history.svg";
import { ReactComponent as MessageIcon } from "../../../../../build/images/nps-dashboard-icons/message.svg";
import { ReactComponent as CloseIcon } from "../../../../../build/images/close-circle.svg";
import { ReactComponent as CaseIcon } from "../../../../../build/images/nps-dashboard-icons/news.svg";

import { ReactComponent as EmailIcon } from "../../../../../build/images/nps-dashboard-icons/channels/e-mail.svg";
import { ReactComponent as GbmIcon } from "../../../../../build/images/nps-dashboard-icons/channels/gbm.svg";
import { ReactComponent as MessengerIcon } from "../../../../../build/images/nps-dashboard-icons/channels/messenger.svg";
import { ReactComponent as SmsIcon } from "../../../../../build/images/nps-dashboard-icons/channels/new-sms-icon.svg";
import { ReactComponent as TelegramIcon } from "../../../../../build/images/nps-dashboard-icons/channels/telegram.svg";
import { ReactComponent as VoiceIcon } from "../../../../../build/images/nps-dashboard-icons/channels/voice.svg";
import { ReactComponent as WebchatIcon } from "../../../../../build/images/nps-dashboard-icons/channels/webchat.svg";
import { ReactComponent as TEAMS } from "../../../../../build/images/channels/teamsSmallTwo.svg";

import {
  getDealStatusCall,
  insertDealCall,
  setDetailsNps,
  startCallActive,
  updateTreatedDealCall,
} from "../../../../../actions";

import { reduceString } from "../../../../../utils/reduceString";
import { Tooltippy } from "../../../../../actions/Tippy";

import "./user-treatment.css";
import AcceptEvaluationCallCenterModal from "../../../../PlatformNps/Modals/AcceptEvaluationCallCenterModal";
import DeletedEvaluationCallCenterModal from "../../../../PlatformNps/Modals/DeletedEvaluationCallCenterModal";
import SatisfactionSelectCSAT from "./SatisfactionSelectCSAT/SatisfactionSelectCSAT";

let interactionId = null;
let arrayHash = [];

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export default function UserTreatment({
  isDrawerOpen,
  onCloseDrawer,
  setUserHistoryDrawer,
  setUserInteractionDrawer,
  setVisibleDrawerCase,
  treatmentData,
  getlistDeal,
  setVisibleDrawerComment,
  setCaseId,
  caseId,
  hiddenDrawerTreatment,
  setHiddenDrawerTreatment,
  getListDealOnClose,
  isCSAT = false,
}) {
  const dispatch = useDispatch();
  const [status, setStatus] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(
    treatmentData.id_deal_status || 1
  );
  const userReducer = useSelector((state) => state.informationusers);
  const [infoTreatment, setInfoTreatment] = useState(treatmentData);
  const connectionsapi = useSelector((state) => state.connectionsapi);
  interactionId = treatmentData.id_atendimento;

  const hasIngDeskPermission = userReducer.nameauth === "IngDesk";

  const handleStatusSave = async (status, nameStatus) => {
    if (treatmentData.id_deal_status !== null) {
      const isClosed = status === 4 ? true : false;
      await updateTreatedDealCall(
        treatmentData.id_atendimento,
        userReducer.id,
        status,
        treatmentData.id_cdr,
        "false",
        isClosed
      );

      /*
      await axios.get(
        `${url_connection}/conn/update-deal?idatendimento=${
          treatmentData.id_atendimento
        }&user_response=${userReducer.id}&id_deal_status=${status}&cdrid=${
          treatmentData.id_cdr
        }&changed_profile=false&closed=${status === 4 ? true : false}`
      );
      */
    } else {
      const idDealStatus = status || 1;
      const isClosed = status === 4 ? true : false;
      await insertDealCall(
        treatmentData.id_atendimento,
        userReducer.id,
        idDealStatus,
        treatmentData.id_cdr,
        "false",
        isClosed
      );
      /*
      await axios.get(
        `${url_connection}/conn/insert-deal?idatendimento=${
          treatmentData.id_atendimento
        }&user_response=${userReducer.id}&id_deal_status=${status || 1}&cdrid=${
          treatmentData.id_cdr
        }&changed_profile=false&closed=${status === 4 ? true : false}`
      );
      */
    }
    setInfoTreatment({
      ...treatmentData,
      id_deal_status: status,
      desc_deal_status: nameStatus,
    });
    onCloseDrawer();
    getlistDeal();
  };

  const csatArray = useMemo(() => {
    try {
      return JSON.parse(treatmentData.csat || "[]");
    } catch (error) {
      console.error("Error parsing csat:", error);
      return [];
    }
  }, [treatmentData.csat]);

  const handleStartCall = (post, mediaid) => {
    dispatch(
      startCallActive(
        mediaid,
        treatmentData.numero_cliente,
        treatmentData.id_cdr
      )
    );
    const updatedTreatmentData = cloneDeep(treatmentData);
    //passa um parâmetro indicando se a tratativa veio do call center e se é CSAT
    updatedTreatmentData.isCallCenter = true;
    updatedTreatmentData.isCSAT = isCSAT;
    dispatch(setDetailsNps(updatedTreatmentData));
  };

  const handleStatusChange = (status, nameStatus) => {
    handleStatusSave(status, nameStatus);
  };

  function getBackgroundColor(npsNote) {
    //se for nps gera a cor de acordo com a nota se for CSAT pega do parâmetro cor_conceito
    if (!isCSAT) {
      if (npsNote >= 0 && npsNote <= 6) {
        return "#c90000";
      } else if (npsNote === 7 || npsNote === 8) {
        return "#F2BD00";
      } else if (npsNote === 9 || npsNote === 10) {
        return "#008908";
      } else {
        return "#c90000";
      }
    } else {
      return infoTreatment.cor_conceito
        ? infoTreatment.cor_conceito
        : "#008908";
    }
  }

  function formatPhoneNumber(phoneNumber) {
    if (!phoneNumber) return "";

    const ddd = phoneNumber.substring(0, 2);
    const number = phoneNumber.substring(2);

    return `(${ddd}) ${number}`;
  }

  function renderMidiaIcon(midiaId) {
    switch (midiaId) {
      case 1:
        return (
          <div className="section-see-history__user__number__midia">
            <VoiceIcon />
          </div>
        );
      case 2:
        return (
          <div className="section-see-history__user__number__midia">
            <WebchatIcon />
          </div>
        );
      case 3:
        return (
          <div className="section-see-history__user__number__midia">
            <EmailIcon />
          </div>
        );
      case 4:
        return (
          <div className="section-see-history__user__number__midia">
            <MessengerIcon />
          </div>
        );
      case 5:
        return (
          <div className="section-see-history__user__number__midia">
            <WhatsappIcon />
          </div>
        );
      case 7:
        return (
          <div className="section-see-history__user__number__midia">
            <WebchatIcon />
          </div>
        );
      case 8:
        return (
          <div className="section-see-history__user__number__midia">
            <TelegramIcon />
          </div>
        );
      case 11:
        return (
          <div className="section-see-history__user__number__midia">
            <GbmIcon />
          </div>
        );
      case 12:
        return (
          <div className="section-see-history__user__number__midia">
            <SmsIcon />
          </div>
        );
      case 15:
        return (
          <div className="section-see-history__user__number__midia">
            <TEAMS />
          </div>
        );
      default:
        return null;
    }
  }

  /**
   * QUALIFICADORES: Se a resposta for 4 ou 5, a tag será verde.
   * Se a resposta for 3, a tag será amarela. Se a resposta for
   * 0, 1 e 2, a tag será vermelha
   */

  useEffect(() => {
    const fetchData = async () => {
      const response = await getDealStatusCall();
      // const response = await getDealStatus();

      if (response.status !== 200) return;

      if (response.status === 200) {
        setStatus(response.data);
      }
    };

    fetchData();
  }, [treatmentData]);

  useEffect(() => {
    //let hour = new Date();
    const hash = getRandomInt(100000, 999999);
    if (localStorage.getItem("url_iframe") !== "") {
      let jsonIngDesk = {
        origin: "ingweb",
        id: "caseCreatedDealing",
        payload: {
          interactionId: treatmentData.id_atendimento,
        },
      };
      connectionsapi.iframe_ref.current.contentWindow.postMessage(
        jsonIngDesk,
        localStorage.getItem("url_iframe")
      );
    }

    window.addEventListener("message", (message) => {
      if (message.data.origin !== "ingdesk") return;

      const { id, payload } = message.data;
      if (!arrayHash[hash]) {
        if (id === "deliveryCaseIdInteraction") {
          if (payload.clientId.length !== 0) {
            setCaseId(payload.clientId[0].id_ticket);
          } else {
            setCaseId(null);
            connectionsapi.iframe_ref.current.contentWindow.postMessage(
              {
                origin: "ingweb",
                id: "getContactIdInteraction",
                telefone: treatmentData.numero_cliente,
              },
              localStorage.getItem("url_iframe")
            );
            let jsonIngDesk = {
              origin: "ingweb",
              id: "currentInteraction",
              payload: {
                clientId: null,
                clientName: treatmentData.nome_cliente,
                channelId: 14,
                channelName: "Pesquisa de Satisfação",
                companyName: treatmentData.unidade,
                destination: treatmentData.numero_cliente,
                protocol: "",
                observation: treatmentData.observacao,
              },
            };
            connectionsapi.iframe_ref.current.contentWindow.postMessage(
              jsonIngDesk,
              localStorage.getItem("url_iframe")
            );
          }
        }

        if (
          id === "sendMeLogInteraction" &&
          interactionId === treatmentData.id_atendimento
        ) {
          let jsonIngDesk = {
            origin: "ingweb",
            id: "logInteraction",
            payload: {
              caseId: payload.caseId,
              typeId: treatmentData.id_midia === 1 ? 1 : 2,
              typeName: treatmentData.id_midia === 1 ? "voz" : "chat",
              clientId: payload.clientId,
              channelId: treatmentData.id_midia,
              channelName: treatmentData.desc_midia,
              interactionId: treatmentData.id_atendimento,
              externalProtocol: "",
              log: {},
              observation: treatmentData.observacao,
            },
          };
          connectionsapi.iframe_ref.current.contentWindow.postMessage(
            jsonIngDesk,
            localStorage.getItem("url_iframe")
          );
          connectionsapi.iframe_ref.current.contentWindow.postMessage(
            {
              origin: "ingweb",
              id: "interactionEnded",
              payload: true,
            },
            localStorage.getItem("url_iframe")
          );
          //setIsSendMe(false);
        }
      }
    });
    function removerListenerTreatment() {
      arrayHash[hash] = true;
      connectionsapi.iframe_ref.current.contentWindow.postMessage(
        {
          origin: "ingweb",
          id: "interactionEnded",
          payload: true,
        },
        localStorage.getItem("url_iframe")
      );
    }
    return () => {
      window.removeEventListener("message", removerListenerTreatment());
    };
  }, [treatmentData, hiddenDrawerTreatment]);

  const handleDrawerCase = () => {
    setHiddenDrawerTreatment(true);
    setVisibleDrawerCase(true);
  };

  const handleViewNote = (note) => {
    if (note >= 9) {
      return "satisfied";
    } else if (note >= 7) {
      return "indiferent";
    } else {
      return "unsatisfied";
    }
  };

  return (
    <div
      className="drawer-container"
      style={{ display: hiddenDrawerTreatment ? "none" : "flex" }}
    >
      <div className={`see-history-container ${isDrawerOpen ? "" : "closed"}`}>
        <header className="see-history-container__header">
          <Typography.H1 color="blue-selected-4" weight={700}>
            Tratativa do usuário
          </Typography.H1>

          <button
            className="see-history-container__header__close"
            onClick={onCloseDrawer}
          >
            <CloseIcon />
          </button>
        </header>

        <main className="see-history-container__content">
          <section className="section-see-history">
            <div className="section-see-history__user">
              <div
                className="section-see-history__user__number"
                style={{
                  backgroundColor: getBackgroundColor(treatmentData.nota_nps),
                  position: "relative",
                }}
              >
                <Typography.H1 weight="700" color="white">
                  {treatmentData.nota_nps}
                </Typography.H1>
                {renderMidiaIcon(treatmentData.id_midia)}
              </div>

              <div className="section-see-history__user__phone-number">
                <Typography.H2 weight="700" color="gray-180">
                  {treatmentData.nome_cliente}
                </Typography.H2>

                <div className="section-see-history__user__phone-number__text">
                  <Typography.H5 weight="400" color="gray-180">
                    {formatPhoneNumber(treatmentData.numero_cliente)}
                  </Typography.H5>
                </div>

                {treatmentData.email_cliente && (
                  <div className="section-see-history__user__phone-number__text">
                    <Tooltippy
                      content={
                        treatmentData.email_cliente ||
                        treatmentData.email_cliente === 0
                          ? treatmentData.email_cliente
                          : ""
                      }
                    >
                      <Typography.H5 weight="400" color="gray-180">
                        {reduceString(treatmentData.email_cliente, 18)}
                      </Typography.H5>
                    </Tooltippy>
                  </div>
                )}

                {treatmentData.nome_campanha ||
                treatmentData.nome_campanha === 0 ? (
                  <div className="section-see-history__user__phone-number__text">
                    <Tooltippy
                      content={
                        treatmentData.nome_campanha ||
                        treatmentData.nome_campanha === 0
                          ? treatmentData.nome_campanha
                          : ""
                      }
                    >
                      <Typography.H5 weight="400" color="gray-180">
                        {reduceString(treatmentData.nome_campanha, 18)}
                      </Typography.H5>
                    </Tooltippy>
                  </div>
                ) : null}
              </div>
            </div>

            <div className="section-see-history__user__phone-buttons">
              {hasIngDeskPermission && (
                <button
                  className="button-see-history"
                  onClick={() => handleDrawerCase()}
                >
                  <CaseIcon />

                  <Typography.H5 weight="400" color="blue-selected-4">
                    {caseId ? "Ver caso" : "Criar caso"}
                  </Typography.H5>
                </button>
              )}
              <button
                className="button-see-history"
                onClick={() => setVisibleDrawerComment(true)}
              >
                <CommentIcon />

                <Typography.H5 weight="400" color="blue-selected-4">
                  Comentários
                </Typography.H5>
              </button>
              <button
                className="button-see-history"
                onClick={() => setUserInteractionDrawer(true)}
              >
                <MessageIcon />

                <Typography.H5 weight="400" color="blue-selected-4">
                  Interações
                </Typography.H5>
              </button>
              <button
                className="button-see-history"
                onClick={() => setUserHistoryDrawer(true)}
              >
                <HistoryIcon />

                <Typography.H5 weight="400" color="blue-selected-4">
                  Notas
                </Typography.H5>
              </button>
            </div>
          </section>

          <section className="section-with-other-information">
            <FieldContainer title="status">
              <StatusSelect
                setSelectedStatus={setSelectedStatus}
                treatmentData={treatmentData}
                selectedStatus={selectedStatus}
                onChange={handleStatusChange}
                statusOptions={status}
              />
            </FieldContainer>

            <FieldContainer
              title="Qualificadores"
              className="field-container-1"
            >
              <div className="section-with-other-information__tags">
                {csatArray.map((item, index) => {
                  const response = item.resposta;

                  let tagStyle = {};
                  let subQualif = JSON.parse(item.subqualificadores);

                  if (response === 4 || response === 5) {
                    tagStyle = { backgroundColor: "#ebf6eb" };
                  } else if (response === 3) {
                    tagStyle = { backgroundColor: "#F2BD00" };
                  } else if (response >= 0 && response <= 2) {
                    tagStyle = { backgroundColor: "#fbebeb" };
                  }

                  return (
                    <div
                      className="section-with-other-information__tags-qualifier"
                      key={index}
                    >
                      <span>{item.pergunta}</span>
                      <div className="section-with-other-information__tags-subqualifier">
                        {subQualif.length === 0 && (
                          <button
                            key={index}
                            className={`section-with-other-information__tags__button`}
                            style={tagStyle}
                          >
                            <Typography.H5
                              weight="500"
                              color={
                                response === 4 || response === 5
                                  ? "green-2"
                                  : response === 3
                                  ? "white"
                                  : "red-2"
                              }
                            >
                              {item.pergunta}
                            </Typography.H5>
                          </button>
                        )}
                        {subQualif.map((qualif) => (
                          <button
                            key={index}
                            className={`section-with-other-information__tags__button`}
                            style={tagStyle}
                          >
                            <Typography.H5
                              weight="500"
                              color={
                                response === 4 || response === 5
                                  ? "green-2"
                                  : response === 3
                                  ? "white"
                                  : "red-2"
                              }
                            >
                              {qualif.desc_subq}
                            </Typography.H5>
                          </button>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            </FieldContainer>
            <FieldContainer title="Dados do atendimento">
              <div className="field-container-2">
                <div className="field-container-2__content">
                  <div className="field-container-2__content__title">
                    Data e hora
                  </div>
                  <div className="field-container-2__content__info">
                    {treatmentData.data_atendimento}
                  </div>
                </div>
                <div className="field-container-2__content">
                  <div className="field-container-2__content__title">Grupo</div>
                  <div className="field-container-2__content__info">
                    {treatmentData.nome_grupo ? treatmentData.nome_grupo : ""}
                  </div>
                </div>
                <div className="field-container-2__content">
                  <div className="field-container-2__content__title">
                    Atendente
                  </div>
                  <div className="field-container-2__content__info">
                    {treatmentData.attendant}
                  </div>
                </div>
                <div className="field-container-2__content">
                  <div className="field-container-2__content__title">
                    Serviço
                  </div>
                  <div className="field-container-2__content__info">
                    {treatmentData.service}
                  </div>
                </div>
              </div>
            </FieldContainer>

            <div className="field-container-response">
              <div className="field-container-response__wrapper">
                <FieldContainer
                  title="Resposta"
                  className="satisfaction-Select-container"
                >
                  {isCSAT ? (
                    <SatisfactionSelectCSAT
                      label={infoTreatment.conceito}
                      color={infoTreatment.cor_conceito}
                    />
                  ) : (
                    <SatisfactionSelect
                      defaultOption={handleViewNote(treatmentData.nota_nps)}
                    />
                  )}
                </FieldContainer>

                <FieldContainer
                  title="Entrar em contato:"
                  className="field-container-button"
                  width={"auto"}
                  htmlFor="Nenhum"
                >
                  <div className="contact-buttons">
                    <button
                      className={
                        selectedStatus === 4
                          ? "contact-buttons__voice-call disabled"
                          : "contact-buttons__voice-call"
                      }
                      onClick={() => {
                        handleStartCall("PlatformNps", 1);
                      }}
                    >
                      <PermPhoneMsgIcon />

                      <Typography.H5 weight="700" color="white">
                        Chamada de voz
                      </Typography.H5>
                    </button>

                    <button
                      className={
                        selectedStatus === 4
                          ? "contact-buttons__whatsapp disabled"
                          : "contact-buttons__whatsapp"
                      }
                      onClick={() => handleStartCall("PlatformNps", 5)}
                    >
                      <WhatsappIcon />

                      <Typography.H5 weight="700" color="white">
                        WhatsApp
                      </Typography.H5>
                    </button>
                  </div>
                </FieldContainer>
              </div>

              <textarea
                cols="20"
                disabled
                placeholder=""
                value={treatmentData.observacao ? treatmentData.observacao : ""}
              />
            </div>
          </section>
        </main>

        <footer className="see-history-container__footer">
          <button
            className={
              selectedStatus === 4 ? "button_delete disabled" : "button_delete"
            }
            onClick={(e) =>
              MicroModal.show("modal-component-deleted-evaluation-modal")
            }
          >
            <DeleteIcon />

            <Typography.H5
              weight={selectedStatus === 4 ? "400" : "700"}
              color={selectedStatus === 4 ? "gray" : "red-2"}
            >
              Excluir resposta
            </Typography.H5>
          </button>
          <button
            className={
              selectedStatus === 4
                ? "button_accept-answer disabled"
                : "button_accept-answer"
            }
            onClick={(e) =>
              MicroModal.show("modal-component-accept-evaluation-modal")
            }
          >
            <CheckCirclIcon />

            <Typography.H5 weight="700" color="white">
              Aceitar resposta
            </Typography.H5>
          </button>
        </footer>

        <AcceptEvaluationCallCenterModal
          modalTitle="Aceitar resposta"
          treatmentData={treatmentData}
          infoTreatment={infoTreatment}
          data={treatmentData}
          getlistDeal={getlistDeal}
          onCloseDrawer={onCloseDrawer}
        />
        <DeletedEvaluationCallCenterModal
          modalTitle="Excluir resposta"
          treatmentData={treatmentData}
          getlistDeal={getListDealOnClose}
          onCloseDrawer={onCloseDrawer}
        />
      </div>
    </div>
  );
}
